import { createDetailAddon, deleteAddonDetail, listVersions, showAddonDetailByVersion, updateDetailAddon }  from "@/apis/addons";

export const RESOURCE_TYPE_ADDON = "addon";

const handleResponse = (response) => {
  if (response.status === "error" || response.status === "Error") {
    throw new Error(response.error);
  } else {
    return response.value;
  }
};

export const AddonDataProvider = {
  getList: async ({ resource, pagination, filters, sorters, meta }) => {
    const response = await listVersions(meta.id);
    const data = response.value;
    return {
        data,
        total: 0,
    };
  },  

  getOne: async ({ resource, id, meta, variables, addonId }) => {
    if(meta.version) {
      const response = await showAddonDetailByVersion(id, meta.version);
      return handleResponse(response);
    } else {
      return {};
    }
  },

  create: async ({ resource, meta, variables}) => {
    const response = await createDetailAddon(meta.id, variables);
    return handleResponse(response);
  },

  update: async ({ resource, id, meta, variables: { data } }) => {
    const response = await updateDetailAddon(id, meta.version, data);
    return response;
  },

  deleteOne: async ({ resource, id, variables:{addonId, version } }) => {
    const response = await deleteAddonDetail( addonId, version);
    return handleResponse(response);
  }
};
